module.exports = __webpack_public_path__ + "static/media/mirror_logo.90d0b930.svg";